/**
 * The app's thin scrollbar for a scrolling list inside a panel: a 1.5px rounded thumb on the border
 * colour, with a stable gutter so the list does not shift when the bar appears.
 *
 * Centralised because the same five utilities were repeated verbatim in every list that scrolls —
 * the workspace switcher, the zone filter bar and the zone card — and a change to the thumb
 * would otherwise have to be found in each.
 */
export const THIN_SCROLLBAR =
  '[scrollbar-gutter:stable] [&::-webkit-scrollbar-thumb]:rounded-full [&::-webkit-scrollbar-thumb]:bg-border [&::-webkit-scrollbar]:w-1.5';
